import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="py-24 bg-brand-emerald text-white relative overflow-hidden" data-id="element-11">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-brand-mint/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3" data-id="element-12"></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-brand-salmon/10 rounded-full blur-3xl translate-y-1/3 -translate-x-1/4" data-id="element-13"></div>

      <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center relative z-10" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-15">
          <h2 className="font-display text-4xl lg:text-5xl xl:text-6xl font-bold mb-6 leading-tight" data-id="element-16">
            Tu cuerpo sabe cómo sanar.
            <br data-id="element-17" />
            Solo necesita las instrucciones correctas.
          </h2>

          <p className="text-xl lg:text-2xl text-brand-mint italic mb-12 font-display" data-id="element-18">
            Descarga tu guía hoy y empieza tu transformación.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-19">
            <a href="#productos" className="inline-flex items-center justify-center border-2 border-white text-white px-8 py-4 rounded-lg font-medium text-lg hover:bg-white hover:text-brand-emerald transition-all duration-300" data-id="element-20">
              Cenas sin Batallas &rarr;
            </a>
            <a href="#productos" className="inline-flex items-center justify-center border-2 border-white text-white px-8 py-4 rounded-lg font-medium text-lg hover:bg-white hover:text-brand-emerald transition-all duration-300" data-id="element-21">
              Resetea tu Cortisol &rarr;
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}